import { useMemo } from "react";
import { useGetGigPieceQuery, useGetGigPiecesQuery } from "./gigPieceEndpoints";
import { GigPiece } from "../../entities/gigPiece";
import { Ids } from "../../reducers/rhapsody";

export function useGigPiece(ids?: Ids) {
  const gigPieceQuery = useGetGigPieceQuery(ids, {
    skip: (ids?.id ?? 0) <= 0,
  });
  const gigPieceEntity = gigPieceQuery.data;

  return useMemo(() => {
    const ret: typeof gigPieceQuery & { gigPiece?: GigPiece | undefined } = {
      ...gigPieceQuery,
    };
    if (gigPieceEntity) ret.gigPiece = new GigPiece(gigPieceEntity);
    return ret;
  }, [gigPieceEntity]);
}

export function useGigPieces() {
  const gigPieceQuery = useGetGigPiecesQuery();
  const gigPieceEntitiesMap = gigPieceQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof gigPieceQuery & {
      gigPieces?: GigPiece[];
      gigPiecesMap?: { [id: number]: GigPiece };
    } = {
      ...gigPieceQuery,
      gigPieces: [],
      gigPiecesMap: {},
    };
    if (gigPieceEntitiesMap) {
      const gigPieces: GigPiece[] = [];
      const gigPiecesMap: { [id: number]: GigPiece } = {};

      for (const key in gigPieceEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(gigPieceEntitiesMap, key)) {
          const c = gigPieceEntitiesMap[key];
          const gigPiece = new GigPiece(c);
          gigPieces.push(gigPiece);
          gigPiecesMap[gigPiece.id] = gigPiece;
        }
      }
      ret.gigPieces = gigPieces;
      ret.gigPiecesMap = gigPiecesMap;
    }

    return ret;
  }, [gigPieceEntitiesMap]);
}
